export default {
  club_name: 'Ålstens GK',
  club_name_short: 'golf',
  stadium_name: '',
  staging_url: 'https://golf.api.fangroup.io',
  prod_url: 'https://golf.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/golf',
  club_logo: '/assets/teams/golf.png',
  app_name: 'golf',
  websale_name: 'golf',
  ntb_team_id: 10066,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'golf',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
